import { z } from "zod";
export const listContractTemplatesQuerySchema = z.object({
    search: z.string().trim().min(1).optional(),
});
